import { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { apiRequest } from '../authConfig.js';
import { getEmbedToken } from '../api.js';
import ReportEmbed from '../components/ReportEmbed.jsx';
import styles from './Report.module.css';

export default function Report() {
  const { reportId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();

  const { workspaceId, reportName } = location.state || {};

  const [embedConfig, setEmbedConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!workspaceId) {
      // If navigated directly without state, go home
      navigate('/', { replace: true });
      return;
    }

    async function fetchToken() {
      try {
        const tokenResponse = await instance.acquireTokenSilent({
          ...apiRequest,
          account: accounts[0],
        });
        const data = await getEmbedToken(tokenResponse.idToken, { reportId, workspaceId });
        setEmbedConfig(data);
      } catch (err) {
        console.error('Failed to get embed token:', err);
        if (err.status === 403) {
          setError('Não tem permissão para aceder a este relatório.');
        } else {
          setError('Erro ao carregar o relatório. Por favor tente novamente.');
        }
      } finally {
        setLoading(false);
      }
    }

    fetchToken();
  }, [reportId, workspaceId, instance, accounts, navigate]);

  return (
    <main className={styles.main}>
      <div className={styles.header}>
        <button className={styles.backBtn} onClick={() => navigate('/')}>
          ← Voltar
        </button>
        <h1 className={styles.title}>{reportName || 'Relatório'}</h1>
      </div>

      {loading && (
        <div className={styles.loading}>
          <div className={styles.spinner} />
          <p>A carregar relatório...</p>
        </div>
      )}

      {error && (
        <div className={styles.errorBox}>
          <p>{error}</p>
          <button className={styles.retryBtn} onClick={() => navigate('/')}>
            Voltar à página inicial
          </button>
        </div>
      )}

      {!loading && !error && embedConfig && (
        <div className={styles.embedWrapper}>
          <ReportEmbed
            embedToken={embedConfig.embedToken}
            embedUrl={embedConfig.embedUrl}
            reportId={embedConfig.reportId}
          />
        </div>
      )}
    </main>
  );
}
